import { OperationVariables, ApolloQueryResult } from '@apollo/client'

import { BookingPermission } from '../../types/bookingPermission'
import BookingPermissionTableHeader from './BookingPermissionTableHeader'
import BookingPermissionTableRow from './BookingPermissionTableRow'
import BookingPermissionTableRowSkeleton from './BookingPermissionTableRow.Skeleton'

type BookingPermissionTableProps = {
  data: BookingPermission[]
  setData: React.Dispatch<React.SetStateAction<BookingPermission[]>>
  loadingForBookingPermissions: boolean
  editMode: boolean
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      tenantBookingPermission: BookingPermission[]
    }>
  >
}

const BookingPermissionTable = ({
  data,
  setData,
  loadingForBookingPermissions,
  editMode,
  refetch
}: BookingPermissionTableProps) => {
  return (
    <div>
      <BookingPermissionTableHeader
        data={data}
        setData={setData}
        editMode={editMode}
        refetch={refetch}
      />
      {loadingForBookingPermissions
        ? Array(6)
            .fill('')
            .map((item, index) => (
              <BookingPermissionTableRowSkeleton
                key={`accommodation-skeleton${item}${index.toString()}`}
                isOdd={index % 2 != 0}
              />
            ))
        : data.map((item, index) => (
            <BookingPermissionTableRow
              key={index}
              item={item}
              isOdd={index % 2 !== 0}
              editMode={editMode}
              setData={setData}
            />
          ))}
    </div>
  )
}

export default BookingPermissionTable
